module.exports = __webpack_public_path__ + "img/class-book.6f54d8fd.png";